export const SUCCESS_BONUS_APPLYING = 'SUCCESS_BONUS_APPLYING';
export const CUSTOMER_NOT_PRESENT = 'CUSTOMER_NOT_PRESENT';
export const CUSTOMER_NOT_ALLOWED = 'CUSTOMER_NOT_ALLOWED';
export const CUSTOMER_SEGMENT_NOT_ALLOWED = 'CUSTOMER_SEGMENT_NOT_ALLOWED';
export const CUSTOMER_NOT_CONFIRMED = 'CUSTOMER_NOT_CONFIRMED';
export const NOT_ENOUGH_BONUS = 'NOT_ENOUGH_BONUS';
export const POSITIONS_NOT_PRESENT = 'POSITIONS_NOT_PRESENT';
export const INVALID_BONUS_AMOUNT = 'INVALID_BONUS_AMOUNT';
export const APPLYING_AMOUNT_IS_BELLOW_MIN_ACCEPTABLE = 'APPLYING_AMOUNT_IS_BELLOW_MIN_ACCEPTABLE';
export const ORDER_AMOUNT_IS_BELLOW_MIN_ACCEPTABLE = 'ORDER_AMOUNT_IS_BELLOW_MIN_ACCEPTABLE';

export const BONUS_APPLYING_RESULT_MESSAGES: Record<string, string> = {
  [CUSTOMER_NOT_PRESENT]: 'Не задан идентификатор покупателя',
  [CUSTOMER_NOT_ALLOWED]: 'Списание баллов для вашего типа покупателя запрещено',
  [CUSTOMER_SEGMENT_NOT_ALLOWED]: 'Списание баллов для вашего сегмента запрещено',
  [CUSTOMER_NOT_CONFIRMED]: 'Покупатель не подтверждён для применения баллов',
  [NOT_ENOUGH_BONUS]: 'Недостаточно баллов для применения',
  [POSITIONS_NOT_PRESENT]: 'Отсутствуют позиции для применения баллов',
  [INVALID_BONUS_AMOUNT]: 'Сумма баллов для применения должна быть положительным числом',
  [APPLYING_AMOUNT_IS_BELLOW_MIN_ACCEPTABLE]: 'Сумма баллов для списания меньше минимально допустимой',
  [ORDER_AMOUNT_IS_BELLOW_MIN_ACCEPTABLE]:
    'Сумма позиций, подходящих для списания баллов, меньше минимальной допустимой',
};

export const DEFAULT_BONUS_APPLYING_ERROR_MESSAGE = 'Не удалось применить баллы';

export function getBonusApplyingErrorMessage(code: string): string {
  return BONUS_APPLYING_RESULT_MESSAGES[code] ?? DEFAULT_BONUS_APPLYING_ERROR_MESSAGE;
}

export function isSuccessfulBonusApplying(code?: string | null): boolean {
  return !code || code === SUCCESS_BONUS_APPLYING;
}
